import type { Ticket } from "@shared/schema";

export type TicketOrigin = "all" | "client" | "revendeur" | "unassigned";
type TicketLinks = Pick<Ticket, "clientId" | "resellerId">;

export function matchesTicketOrigin(ticket: TicketLinks, origin: TicketOrigin): boolean {
  switch (origin) {
    case "client": return !!ticket.clientId;
    case "revendeur": return !!ticket.resellerId;
    case "unassigned": return !ticket.clientId && !ticket.resellerId;
    default: return true;
  }
}

/** Input has all OTHER filters applied, never the selected origin. */
export function countTicketOrigins(tickets: readonly TicketLinks[]): Record<TicketOrigin, number> {
  const counts = { all: tickets.length, client: 0, revendeur: 0, unassigned: 0 };
  for (const ticket of tickets) {
    if (ticket.clientId) counts.client++;
    if (ticket.resellerId) counts.revendeur++;
    if (!ticket.clientId && !ticket.resellerId) counts.unassigned++;
  }
  return counts;
}
